import { useLocation } from 'react-router-dom';
import qs from 'qs';

export const useQueryParams = () => {
  const { search } = useLocation();
  if (search) return qs.parse(search.slice(1));

  return null;
};
